import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css"
import App from './App';
// after App: the brand overrides win over the component styles
import './brand/brand.css'
import BRAND from './brand'

import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import * as Sentry from "@sentry/react";
import { Capacitor } from '@capacitor/core';
import { IS_NATIVE, loadAccessToken } from './services/auth/nativeAuth';
import { openLinksInNativeBrowser } from './api/nativeFiles';

const container = document.getElementById('root');
const root = createRoot(container);

Sentry.init({
  dsn: "https://21bac00adb4268c18373e300de25e53c@o1240163.ingest.us.sentry.io/4507256366432256",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT,
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_SESSION_RATE),
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.3,// If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (BRAND.fontsUrl)
  document.head.append(Object.assign(document.createElement('link'), { rel: 'stylesheet', href: BRAND.fontsUrl }));

if (IS_NATIVE) {
  // Android: without viewport-fit=cover the OS keeps the webview out of the system bars.
  // iOS keeps cover: the native container already starts below the status bar (SceneDelegate)
  // and env(safe-area-inset-bottom) is needed to clear the home indicator.
  if (Capacitor.getPlatform() === 'android')
    document.querySelector('meta[name=viewport]').content = 'width=device-width, initial-scale=1';
  openLinksInNativeBrowser();
}

// the stored session token must be in memory before the first authenticated call
loadAccessToken().finally(() => root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// native apps ship their assets: no offline cache (and no stale bundles after an update)
if (!IS_NATIVE) serviceWorkerRegistration.register();
reportWebVitals();
